module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8IpNU"))).then(() => module.bundle.root('cvs7o'));